import React, { Dispatch, SetStateAction, useState } from 'react';
import { Block } from '../../../../../../types/shared/blocks';
import FeetInchesInput from '../FeetInchesInputV2';
import EdgeType from '../../../../../../enums/edgeType';
import EdgeLabel from '../../../../../../enums/edgeLabel';
import {
	MAX_DECK_DEPTH,
	MAX_DECK_HEIGHT,
	MAX_DECK_WIDTH,
} from '../../../../../../constants/limits';
import {
	Stack,
	Box,
	FormControlLabel,
	Radio,
	RadioGroup,
	styled,
	Typography,
} from '@mui/material';
import { useQuoteState } from 'src/stateProviders/QuoteStateProvider';

const StyledLabel = styled(Typography)({
	fontWeight: 500,
	fontSize: 14,
});

const LandingPopper: React.FC<{
	block: Block;
	setExternalBlockData: Dispatch<SetStateAction<Block>>;
}> = ({ block, setExternalBlockData }) => {
	const [blockData, setBlockData] = useState(block);
	const quoteState = useQuoteState();

	const blockAttachedEdge = block.edges.find(
		(ed) => ed.type == EdgeType.BLOCK_ATTACHED
	);

	const displayWidthDimension =
		blockAttachedEdge?.label == 'Top' || blockAttachedEdge?.label == 'Bottom'
			? 'width'
			: 'depth';

	const handleWidthChange = (inches) => {
		if (inches > MAX_DECK_WIDTH) return;
		const updatedData = {
			...blockData,
			dimensions: {
				width: inches,
				depth: blockData.dimensions.depth,
				height: blockData.dimensions.height,
			},
			displayDimensions: {
				width:
					displayWidthDimension == 'width'
						? inches
						: blockData.dimensions.depth,
				height:
					displayWidthDimension == 'width'
						? blockData.dimensions.depth
						: inches,
			},
			edges: blockData.edges.map((edge) => {
				if (displayWidthDimension == 'width') {
					if (edge.label == EdgeLabel.TOP || edge.label == EdgeLabel.BOTTOM) {
						return {
							...edge,
							length: inches,
						};
					}
					return edge;
				} else {
					if (edge.label == EdgeLabel.LEFT || edge.label == EdgeLabel.RIGHT) {
						return {
							...edge,
							length: inches,
						};
					}

					return edge;
				}
			}),
		};

		setBlockData(updatedData);
		setExternalBlockData(updatedData);
	};

	const handleDepthChange = (inches) => {
		if (inches > MAX_DECK_DEPTH) return;
		const updatedData = {
			...blockData,
			dimensions: {
				width: blockData.dimensions.width,
				depth: inches,
				height: blockData.dimensions.height,
			},
			displayDimensions: {
				width:
					displayWidthDimension == 'width'
						? blockData.dimensions.width
						: inches,
				height:
					displayWidthDimension == 'width'
						? inches
						: blockData.dimensions.width,
			},
			edges: blockData.edges.map((edge) => {
				if (displayWidthDimension != 'width') {
					if (edge.label == EdgeLabel.TOP || edge.label == EdgeLabel.BOTTOM) {
						return {
							...edge,
							length: inches,
						};
					}
					return edge;
				} else {
					if (edge.label == EdgeLabel.LEFT || edge.label == EdgeLabel.RIGHT) {
						return {
							...edge,
							length: inches,
						};
					}

					return edge;
				}
			}),
		};

		setBlockData(updatedData);
		setExternalBlockData(updatedData);
	};

	return (
		<Stack spacing={2}>
			{quoteState.reface && (
				<RadioGroup
					value={blockData.reface ? 'Reface' : 'Rebuild'}
					onChange={(e) => {
						setBlockData((prev) => ({
							...prev,
							reface: e.target.value == 'Reface',
						}));

						setExternalBlockData((prev) => ({
							...prev,
							reface: e.target.value == 'Reface',
						}));
					}}
				>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'start',
						}}
					>
						<FormControlLabel
							value={'Reface'}
							control={<Radio />}
							label={<StyledLabel>Reface</StyledLabel>}
						/>
						<FormControlLabel
							value={'Rebuild'}
							control={<Radio />}
							label={<StyledLabel>Rebuild</StyledLabel>}
						/>
					</Box>
				</RadioGroup>
			)}

			<FeetInchesInput
				valueInches={blockData.dimensions.depth}
				labelInches="Depth"
				onChange={handleDepthChange}
				maxFeet={MAX_DECK_DEPTH / 12}
			/>

			<FeetInchesInput
				valueInches={blockData.dimensions.width}
				labelInches="Width"
				onChange={handleWidthChange}
				maxFeet={MAX_DECK_WIDTH / 12}
			/>

			<FeetInchesInput
				valueInches={blockData.dimensions.height}
				labelInches="Height"
				onChange={() => {}}
				locked={true}
				maxFeet={MAX_DECK_HEIGHT / 12}
			/>
		</Stack>
	);
};

export default LandingPopper;
